const fromdata = [{
		inputdata: "",
		title: "年份",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "datey",
		width: "210px",
		disabled: false,
		lablewith: "110px",
	},
	{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "select",
		width: "210px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "经销商",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "selectautocompletes",
		width: "220px",
		btx: false,
		lablewith: "110px",
		options: [],
	},
	{
		inputdata: "",
		title: "评分",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "input",
		width: "200px",
		lablewith: "110px",
		btx: false,
	},
];
export default fromdata;
